import rawQuestions from './questions.json';
import type { Difficulty, Question } from './types';

const ALL = rawQuestions as Question[];

export function allQuestions(): Question[] {
  return ALL;
}

export interface QuestionFilter {
  difficulty?: Difficulty | 'all';
}

/** Return questions matching the filter. A missing/'all' difficulty matches everything. */
export function filterQuestions(filter: QuestionFilter = {}): Question[] {
  const { difficulty = 'all' } = filter;
  return ALL.filter((q) => difficulty === 'all' || q.difficulty === difficulty);
}
